import { type ApiErrorResponse, type Exception } from './types';

export function getExceptionMessage(input: Exception) {
  if (typeof input === 'string') {
    return input;
  }

  if (input instanceof Error) {
    return input.message;
  }

  if (typeof input === 'object' && !Array.isArray(input) && 'error' in input) {
    return (input.error as ApiErrorResponse).message;
  }

  return 'An error has occured';
}
